import { useState } from 'react';
import FAQSchema from '../../seo/FAQSchema';
import '../Homepage/FAQ.css';

const FBMFAQs = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      id: 1,
      question: 'What performance metrics do you meet for Amazon FBM?',
      answer: 'We operate at 99%+ on‑time shipment, 98%+ Buy Shipping compliance and under 0.5% cancellations, with daily reporting and exception reviews.'
    },
    {
      id: 2,
      question: 'How fast do you upload tracking for FBM orders?',
      answer: 'Tracking uploads immediately after label generation to protect Valid Tracking Rate and buyer notifications.'
    },
    {
      id: 3,
      question: 'Do you support weekend dispatch for FBM?',
      answer: 'Yes. We dispatch seven days a week within agreed cut‑offs to keep delivery promises consistent.'
    },
    {
      id: 4,
      question: 'Can you handle peak volume without missing SLAs?',
      answer: 'Yes. We scale packing pods, batch by SKU and extend shifts during peaks like Q4 and promos while holding metrics.'
    },
    {
      id: 5,
      question: 'Do you purchase labels via Amazon Buy Shipping?',
      answer: 'Yes. Labels are purchased via Buy Shipping to maintain compliance and ensure tracking is registered correctly.'
    },
    {
      id: 6,
      question: 'What is your returns processing SLA for FBM?',
      answer: 'Returns are scanned and graded within 24–48 hours with reason codes and sellable items are restocked promptly.'
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="faqs-section">
      <FAQSchema
        faqs={faqs.map(({ question, answer }) => ({ question, answer }))}
        id="fbm-faq-schema"
        nonce="ppp-2026-gtm-nonce"
      />
      <div className="faqs-container">
        <div className="faqs-header">
          <h2 className="faqs-title">Amazon FBM: Performance &amp; Compliance FAQs</h2>
          <p className="faqs-description">
            Learn how our Amazon FBM Fulfilment UK service protects your seller metrics through reliable fulfilment, SLA
            compliance, accurate dispatch, and real-time operational visibility.
          </p>
        </div>

        <div className="faqs-content">
          <div className="faqs-list">
            {faqs.map((faq, index) => (
              <div 
                key={faq.id} 
                className={`faq-item ${openIndex === index ? 'faq-open' : ''}`}
              >
                <div 
                  className="faq-question-wrapper"
                  onClick={() => toggleFAQ(index)}
                >
                  <h3 className="faq-question">{faq.question}</h3>
                  <button 
                    className={`faq-toggle ${openIndex === index ? 'faq-toggle-open' : ''}`}
                    aria-label={openIndex === index ? 'Close answer' : 'Open answer'}
                    onClick={(e) => {
                      e.stopPropagation();
                      toggleFAQ(index);
                    }}
                  >
                    <svg width="32" height="32" viewBox="0 0 20 20" fill="none">
                      {openIndex === index ? (
                        <path d="M5 10H15" stroke="currentColor" strokeWidth="3.5" strokeLinecap="round"/>
                      ) : (
                        <>
                          <path d="M10 5V15" stroke="currentColor" strokeWidth="3.5" strokeLinecap="round"/>
                          <path d="M5 10H15" stroke="currentColor" strokeWidth="3.5" strokeLinecap="round"/>
                        </>
                      )}
                    </svg>
                  </button>
                </div>
                <div className={`faq-answer ${openIndex === index ? 'faq-answer-open' : ''}`}>
                  <p>{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="faqs-image-wrapper">
            <img 
              src="/Images/merchent/FAQ_image.webp" 
              alt="Amazon FBM FAQs" 
              className="faqs-image"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default FBMFAQs;

